import React from 'react'
import moment from 'moment';
import { utils_tool } from '@/tool'
import { getLocationOrgin } from '@/utils/commonUtils';
let { Session } = utils_tool

//配置项
let componentName = 'examinationRecord'
let ref;

const columns = (commentData) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '姓名',
      name: 'fullName',
      dataIndex: 'fullName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '账号',
      name: 'userName',
      dataIndex: 'userName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '组织名称',
      name: 'orgName',
      dataIndex: 'orgName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '组织编码',
      name: 'orgCode',
      dataIndex: 'orgCode',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '岗位',
      name: 'positionName',
      dataIndex: 'positionName',
      tableItem: {}
    },
    {
      title: '考试时间',
      name: 'timeInterval',
      dataIndex: 'timeInterval',
      searchItem: {
        type: 'date~',
        showTime: true,
      },
    },
    {
      title: '考试开始时间',
      name: 'startDate',
      dataIndex: 'startDate',
      tableItem: {}
    },
    {
      title: '考试结束时间',
      name: 'endDate',
      dataIndex: 'endDate',
      tableItem: {}
    },
    {
      title: '状态',
      name: 'state',
      tableItem: {},
      searchItem: {
        type: 'select'
      },
      dict: [
        { code: 0, codeName: '待批阅' },
        { code: 1, codeName: '已批阅' },
      ]
    },
    {
      title: '批阅人',
      name: 'updateFullName',
      dataIndex: 'updateFullName',
      tableItem: {}
    },
    {
      title: '批阅时间',
      name: 'updateTime',
      dataIndex: 'updateTime',
      tableItem: {}
    },
    {
      title: '当前批阅人',
      name: 'reviewFullName',
      dataIndex: 'reviewFullName',
      tableItem: {}
    },
  ]
}
  ;

const templateConfig = () => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns(),
        btnAccessCheck: false,
        searchBarProps: {
          // collapse: false,
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ],
          dataFormat: (v) => {
            let value = Object.assign([], v)
            if (value['timeInterval'] && value['timeInterval'].length === 2) {
              value['startDate'] = moment(value['timeInterval'][0]).format('YYYY-MM-DD HH:mm:00')
              value['endDate'] = moment(value['timeInterval'][1]).format('YYYY-MM-DD HH:mm:00')
            }
            return value
          },
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['reviewOrRebatch', 'look'],
        rowOperateView: [
          {
            key: 'reviewOrRebatch',
            custom: true,
            params: { children: '有效' },
            textFormat: {
              recordKey: 'state',
              dirt: { 1: '复批', 0: '批阅', }
            },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'openUrl'
              },
              formatParams: (rows, record, filters, callback) => {
                let url = getLocationOrgin() + '/#/subjectiveReview/review'
                // 跳转到新页面,先存储当前行信息
                Session.set('examinationReviewRecord', record)
                window.open(url, '_blank')
                return null
              }
            },
          },
          {
            key: 'look',
            custom: true,
            params: { children: '查看' },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'openUrl'
              },
              formatParams: (rows, record, filters, callback) => {
                let id = record.id;
                let url = getLocationOrgin() + '/#/subjectiveReview/look'
                // 跳转到新页面,先存储当前行信息
                Session.set('examinationReviewRecord', record)
                window.open(url, '_blank')
                return null
              }
            },
          },
        ]
      }
    }
  }
};


const apis = (examId) => {
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { pageNum: 1, pageSize: 10, examId }
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: { examId }
      }
    }
  };
}

let reduxTemplateCofig = (args) => {
  let { examId } = args
  return {
    apis: apis(examId),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
